import { onLCP, onCLS, onINP, onFCP, onTTFB } from 'web-vitals/attribution'
import type { Rating, WebVitalAttribution, WebVitalMetric, WebVitalName } from './types'
import { getReporter } from './reporter'

/**
 * 初始化 Core Web Vitals 采集（含归因信息）
 *
 * 监听 LCP、CLS、INP、FCP、TTFB 五项核心指标，
 * 采集到最终值后推入 reporter 缓冲区，同时提取归因信息用于定位根因
 */
export function setupWebVitals(): void {
  onLCP(metric => {
    const reporter = getReporter()
    if (!reporter) return

    const attribution: WebVitalAttribution = {}
    if (metric.attribution) {
      const el = metric.attribution.element
      if (el) {
        const tag = el.match(/^<(\w+)/)?.[1]?.toLowerCase() || ''
        if (['img', 'video', 'svg'].includes(tag)) {
          attribution.elementType = tag
        } else {
          attribution.elementType = tag ? 'text' : 'other'
        }
      }
    }

    const entry: WebVitalMetric = {
      name: 'LCP',
      value: metric.value,
      rating: metric.rating as Rating,
      navigationType: metric.navigationType,
      attribution,
    }
    reporter.addWebVital(entry)
  })

  onCLS(metric => {
    const reporter = getReporter()
    if (!reporter) return

    const attribution: WebVitalAttribution = {}
    if (metric.attribution?.largestShiftTarget) {
      attribution.shiftTarget = metric.attribution.largestShiftTarget.slice(0, 64)
    }

    const entry: WebVitalMetric = {
      name: 'CLS',
      value: metric.value,
      rating: metric.rating as Rating,
      navigationType: metric.navigationType,
      attribution,
    }
    reporter.addWebVital(entry)
  })

  onINP(metric => {
    const reporter = getReporter()
    if (!reporter) return

    const attribution: WebVitalAttribution = {}
    if (metric.attribution?.interactionType) {
      attribution.eventType = metric.attribution.interactionType
    }

    const entry: WebVitalMetric = {
      name: 'INP',
      value: metric.value,
      rating: metric.rating as Rating,
      navigationType: metric.navigationType,
      attribution,
    }
    reporter.addWebVital(entry)
  })

  const report = (name: WebVitalName) => {
    return (metric: { value: number; rating: string; navigationType: string }) => {
      const reporter = getReporter()
      if (!reporter) return

      const entry: WebVitalMetric = {
        name,
        value: metric.value,
        rating: metric.rating as Rating,
        navigationType: metric.navigationType,
      }
      reporter.addWebVital(entry)
    }
  }

  onFCP(report('FCP'))
  onTTFB(report('TTFB'))
}
